import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';

export const isProOrPartyPassUser = (subscriptionPlanName: string | undefined) =>
  Boolean(
    subscriptionPlanName && [PLAN_NAME_PRO, PLAN_NAME_PARTY_PASS].includes(subscriptionPlanName)
  );

// TODO: When Step 4 MW is ready, revert these temporary changes
// const STEP_4_UX_REFRESH_MW_EXP_NAME = 'test_step-4-refresh-mw';
const STEP_4_UX_REFRESH_DESKTOP_EXP_NAME = 'test_step-4-refresh-desktop';
export const isInStep4RefreshVariation = (isDesktop: boolean, readonly = false) => {
  // const expName = isDesktop ? STEP_4_UX_REFRESH_DESKTOP_EXP_NAME : STEP_4_UX_REFRESH_MW_EXP_NAME;
  // return evite.experiments.inVariation(expName, 'variant', false, readonly);
  if (!isDesktop) return false;
  return evite.experiments.inVariation(
    STEP_4_UX_REFRESH_DESKTOP_EXP_NAME,
    'variant',
    false,
    readonly
  );
};
